export enum Role {
  PAMA_ADMIN = 'pama-admin',
  PAMA_USER = 'pama-demandeur',
  PAMA_VALIDATEUR = 'pama-valideur'
}
